export var getCoordinates = function (state) { return state.location.coordinates; };
